import { CheckoutSession } from '@nemuru-eng/js-api-client';

import { DistributionCard } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/components/DistributionHistoryDialog/components/DistributionCard';
import { CheckoutSessionHpp } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/entities/CheckoutSessionHpp';
import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { Text } from '@/components/shared/components/Text';

interface DistributionHistoryDialogProps {
  checkoutSession: CheckoutSession;
  hppId: string;
  opened: boolean;
  setOpened: (opened: boolean) => void;
}

export const DistributionHistoryDialog = ({
  checkoutSession,
  hppId,
  opened,
  setOpened,
}: DistributionHistoryDialogProps) => {
  const handleClose = () => {
    setOpened(false);
  };

  const { sortedDistributionsBySentAt } = new CheckoutSessionHpp(checkoutSession);

  return (
    <ActionDialog
      opened={opened}
      setOpened={setOpened}
      handleClose={handleClose}
      Title={<Text tId={'DISTRIBUTIONS_HISTORY'} />}
      Description={<Text tId={'DISTRIBUTIONS_HISTORY_DESCRIPTION'} />}
      dialogProps={{ maxWidth: 'md' }}
    >
      <div>
        {sortedDistributionsBySentAt.map((distribution) => (
          <DistributionCard key={distribution.id} distribution={distribution} hppId={hppId} />
        ))}
      </div>
    </ActionDialog>
  );
};
